<script>
import { delete_file, getUploadFile_by_not } from "@/api/modules/common";

export default {
  name: "index",
  props: {
    value: {
      default: () => [],
    },
    maxCount: {
      default: () => 9,
    },
    accept: {
      default: () => "image/*",
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  watch: {
    value: {
      handler(newVal) {
        console.log(newVal, 2332);
        this.fileList = newVal || [];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    dataURLtoFile(dataurl, name) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name.split(".")[0] + ".png", { type: mime });
    },
    compressImg(file, that) {
      let files;
      let fileSize = parseFloat(parseInt(file["size"]) / 1024 / 1024).toFixed(
        2
      );
      let read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve) {
        read.onload = function (e) {
          let img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            const w = this.width,
              h = this.height;
            //生成canvas
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            let base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              console.log(333);
              base64 = canvas.toDataURL(file["type"], 1);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于4M 那么压缩0.5
              console.log(444);
              base64 = canvas.toDataURL(file["type"], 0.7);
            } else {
              console.log(5555);
              //如果图片超过4m 那么压缩0.2
              base64 = canvas.toDataURL(file["type"], 0.5);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.dataURLtoFile(base64, file.name); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },
    async afterRead(file, { index }) {
      this.$utils.showLoading("上传中");
      // console.log(file);
      // let newFile = null;
      // if (file.file.type.indexOf("image") === -1) {
      //   newFile = file.file;
      // } else {
      //   newFile = await this.compressImg(file.file, this);
      // }

      const formData = new FormData();
      formData.append("file", file.file);
      const { code, data } = await getUploadFile_by_not(formData);
      this.$utils.hideLoading();
      if (code === 0 && data) {
        this.fileList.splice(index, 1, {
          ...this.fileList[index],
          ...data,
        });
        this.$emit("input", this.fileList);
      }
    },
    beforeDelete(row, { index }) {
      this.fileList.splice(index, 1);
      this.$emit("input", this.fileList);
      delete_file({
        ossFileName: row?.ossFileName,
      });
    },
  },
};
</script>

<template>
  <van-uploader
    :max-count="maxCount"
    :accept="accept"
    :before-delete="beforeDelete"
    :after-read="afterRead"
    v-model="fileList"
  />
</template>

<style scoped lang="scss"></style>
